import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { Globals } from '../globals';

interface Country {
    active: number;
    createdAt: any;
    name: string;
    code: string;
    updatedAt: any;
}

interface CountryId extends Country {
    id: string;
}

@Injectable()
export class CountryService {

    collection: string;

    constructor(private afs: AngularFirestore) {
        this.collection = Globals.COUNTRY_COLLECTION;
    }

    postCountry(countryObject: any) {
        let countryCollection = this.afs.collection(this.collection);

        return countryCollection.add(countryObject).then(function(docRef) {
            // console.log('Document added with ID: ', docRef.id);
        }).catch(function(error) {
            // console.error('Error adding document: ', error);
        });
    }

    postCountryWithId(countryObject: any, id$: string) {
        let countryCollection = this.afs.collection(this.collection);

        return countryCollection.doc(id$).set(countryObject).then(function(docRef) {
            // console.log('Document added with ID: ', docRef.id);
        }).catch(function(error) {
            // console.error('Error adding document: ', error);
        });
    }

    getCountries() {
        let countryCollection = this.afs.collection(this.collection, ref => ref.orderBy('name'));

        let countries = countryCollection.snapshotChanges().map(actions => {
            console.log(actions);
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                const data = a.payload.doc.data() as Country;

                const name = data.name;

                return { id$, name };
            });
        }).map(object => object);

        return countries;
    }

    getCountry(id$: string) {
        let countryDocument = this.afs.doc(this.collection + '/' + id$);

        let country = countryDocument.valueChanges();

        return country.map(object => object);
    }

    putCountry(countryObject: any, id$: string) {
        let countryCollection = this.afs.collection(this.collection);

        return countryCollection.doc(id$).update(countryObject).then(function() {
            // console.log('Document updated');
        }).catch(function(error) {
            // console.error('Error updating document: ', error);
        });
    }

    delCountry(id$: string) {
        if(!confirm('¿Desea eliminar?')) return;
        let countryDocument = this.afs.doc(this.collection + '/' + id$);

        return countryDocument .delete().then(function() {
            // console.log('Document deleted');
        }).catch(function(error) {
            // console.error('Error deleting document: ', error);
        });
    }

}
